var exports = {
  "SA": "VoiceConnectionStatus.module__voiceConnectionContainer___bm5GQU",
  "jf": "VoiceConnectionStatus.module__statusRow___bm5GQU",
  "Tm": "VoiceConnectionStatus.module__channelAvatarStack___bm5GQU",
  "kR": "VoiceConnectionStatus.module__signalIcon___bm5GQU",
  "rI": "VoiceConnectionStatus.module__statusButton___bm5GQU",
  "QQ": "VoiceConnectionStatus.module__statusConnected___bm5GQU",
  "Rg": "VoiceConnectionStatus.module__statusConnecting___bm5GQU",
  "iA": "VoiceConnectionStatus.module__statusDisconnected___bm5GQU",
  "ne": "VoiceConnectionStatus.module__controls___bm5GQU",
  "uH": "VoiceConnectionStatus.module__controlButton___bm5GQU",
  "wH": "VoiceConnectionStatus.module__selected___bm5GQU",
  "Kk": "VoiceConnectionStatus.module__icon___bm5GQU",
  "Hd": "VoiceConnectionStatus.module__connectionInfo___bm5GQU",
  "J3": "VoiceConnectionStatus.module__channelSourceRow___bm5GQU",
  "Dt": "VoiceConnectionStatus.module__channelSourceLink___bm5GQU",
  "_R": "VoiceConnectionStatus.module__channelSourceText___bm5GQU",
  "wl": "VoiceConnectionStatus.module__channelSourceChannel___bm5GQU",
  "EF": "VoiceConnectionStatus.module__channelSourceSeparator___bm5GQU",
  "_u": "VoiceConnectionStatus.module__channelSourceGuild___bm5GQU",
  "wt": "VoiceConnectionStatus.module__connectionIdRow___bm5GQU",
  "TR": "VoiceConnectionStatus.module__connectionIdValue___bm5GQU",
  "Gh": "VoiceConnectionStatus.module__connectionIdValueText___bm5GQU",
  "Hz": "VoiceConnectionStatus.module__connectionIdIcon___bm5GQU",
  "EU": "VoiceConnectionStatus.module__mediaSection___bm5GQU",
  "LA": "VoiceConnectionStatus.module__mediaButton___bm5GQU",
  "A1": "VoiceConnectionStatus.module__cameraActive___bm5GQU",
  "Cb": "VoiceConnectionStatus.module__screenShareActive___bm5GQU",
  "cU": "VoiceConnectionStatus.module__mediaIcon___bm5GQU",
  "jC": "VoiceConnectionStatus.module__popoutContainer___bm5GQU",
  "oO": "VoiceConnectionStatus.module__popoutBodyScroller___bm5GQU",
  "$V": "VoiceConnectionStatus.module__popoutBodyContent___bm5GQU",
  "hY": "VoiceConnectionStatus.module__popoutHeader___bm5GQU",
  "Gb": "VoiceConnectionStatus.module__popoutTitle___bm5GQU",
  "IZ": "VoiceConnectionStatus.module__popoutCloseButton___bm5GQU",
  "nO": "VoiceConnectionStatus.module__popoutStats___bm5GQU",
  "u$": "VoiceConnectionStatus.module__popoutStatsSection___bm5GQU",
  "yk": "VoiceConnectionStatus.module__popoutStatsSectionTitle___bm5GQU",
  "r6": "VoiceConnectionStatus.module__popoutStatsSectionRows___bm5GQU",
  "m1": "VoiceConnectionStatus.module__detailedStatsAccordion___bm5GQU",
  "G8": "VoiceConnectionStatus.module__detailedStatsButton___bm5GQU",
  "X6": "VoiceConnectionStatus.module__detailedStatsButtonText___bm5GQU",
  "VV": "VoiceConnectionStatus.module__detailedStatsCaret___bm5GQU",
  "hM": "VoiceConnectionStatus.module__detailedStatsContent___bm5GQU",
  "cl": "VoiceConnectionStatus.module__detailedStatsInner___bm5GQU",
  "gm": "VoiceConnectionStatus.module__popoutStatRow___bm5GQU",
  "Ub": "VoiceConnectionStatus.module__popoutStatLabel___bm5GQU",
  "Fz": "VoiceConnectionStatus.module__popoutStatValue___bm5GQU",
  "ep": "VoiceConnectionStatus.module__popoutStatTextValue___bm5GQU",
  "mp": "VoiceConnectionStatus.module__deviceBadge___bm5GQU",
  "Vs": "VoiceConnectionStatus.module__deviceBadgeText___bm5GQU",
  "hn": "VoiceConnectionStatus.module__endpointBadge___bm5GQU",
  "iu": "VoiceConnectionStatus.module__endpointBadgeText___bm5GQU",
  "_v": "VoiceConnectionStatus.module__chartContainer___bm5GQU",
  "nS": "VoiceConnectionStatus.module__chartSvg___bm5GQU",
  "$s": "VoiceConnectionStatus.module__gridLine___bm5GQU",
  "rK": "VoiceConnectionStatus.module__gridLineHorizontal___bm5GQU",
  "eB": "VoiceConnectionStatus.module__gridText___bm5GQU",
  "BC": "VoiceConnectionStatus.module__chartLine___bm5GQU",
  "Pi": "VoiceConnectionStatus.module__chartPoint___bm5GQU",
  "Hh": "VoiceConnectionStatus.module__textGreen___bm5GQU",
  "NV": "VoiceConnectionStatus.module__textBackgroundModifierHover___bm5GQU",
  "Bx": "VoiceConnectionStatus.module__iconSmall___bm5GQU",
  "Kt": "VoiceConnectionStatus.module__deviceIcon___bm5GQU",
  "hz": "VoiceConnectionStatus.module__lockIcon___bm5GQU",
  "Gy": "VoiceConnectionStatus.module__nsModalContent___bm5GQU",
  "uU": "VoiceConnectionStatus.module__nsOptions___bm5GQU",
};

module.exports = exports;
